import { render, staticRenderFns } from "./SupportsDashboard.vue?vue&type=template&id=23292802&scoped=true&"
import script from "./SupportsDashboard.vue?vue&type=script&lang=js&"
export * from "./SupportsDashboard.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./SupportsDashboard.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./SupportsDashboard.vue?vue&type=style&index=2&id=23292802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23292802",
  null
  
)

export default component.exports